
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Award } from 'lucide-react';
import { TableCell, TableRow } from "@/components/ui/table";
import Button from '@/components/ui-elements/button';
import TierSelect from './TierSelect';
import { Database } from '@/integrations/supabase/types';

type CustomerProfile = Database['public']['Tables']['customer_profiles']['Row'];

interface UsersTableProps {
  users: CustomerProfile[];
  loading: boolean;
  onSelectUser: (user: CustomerProfile) => void;
  onUpdateTier: (userId: string, newTier: string) => void;
}

const UsersTable: React.FC<UsersTableProps> = ({ 
  users, 
  loading, 
  onSelectUser,
  onUpdateTier 
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <TableRow>
        <TableCell colSpan={6} className="text-center py-4">
          {t('admin.loading')}
        </TableCell>
      </TableRow>
    );
  }

  if (users.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={6} className="text-center py-4">
          {t('admin.noUsersFound')}
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {users.map((user) => (
        <TableRow key={user.id}>
          <TableCell>
            {user.first_name} {user.last_name}
          </TableCell>
          <TableCell>{user.email}</TableCell>
          <TableCell>{user.points_balance}</TableCell>
          <TableCell>
            <TierSelect
              value={user.tier || 'standard'}
              onChange={(value) => onUpdateTier(user.id, value)}
            />
          </TableCell>
          <TableCell>
            {new Date(user.created_at).toLocaleDateString()}
          </TableCell>
          <TableCell>
            <Button 
              variant="outline" 
              size="sm"
              leftIcon={<Award className="h-4 w-4" />}
              onClick={() => onSelectUser(user)}
            >
              {t('admin.addPoints')}
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default UsersTable;
